export const API_EXTERNAL_ENDPOINT = 'owners/:id'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/owners/detail'
